export default __webpack_public_path__ + "static/media/logo-akthi.6c433fda.svg";